"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowTheQueenOptions = void 0;
/** FollowTheQueenOptions.ts
 *
 * Game Options for FollowTheQueen.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.FollowTheQueenOptions = {
    versions: [
        {
            title: "7 Cards",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [defaultOptions_1.optionNoneDefault, defaultOptions_1.optionBuyLastCardUp],
    wildcards: [defaultOptions_1.wildcardQueensAndFollowersDefault],
};
//# sourceMappingURL=FollowTheQueenOptions.js.map